module.exports = __webpack_public_path__ + "static/media/dislike-1.a5df86c3.svg";